export enum Steps {
    InitialAssessment = "initial-assessment",
    Learning = "learning",
    LearningRecordTab = "learning-record-tab",
    AssignTarget = "assign-target"
}
